import { render, staticRenderFns } from "./chimp.vue?vue&type=template&id=52944ba9&"
import script from "./chimp.vue?vue&type=script&lang=ts&"
export * from "./chimp.vue?vue&type=script&lang=ts&"
import style0 from "./chimp.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports